<template>
  <vue-modal
    :name="modalName"
    :pivotY="0.15"
    :max-width="maxWidthModal"
    :width="widthModal"
    :height="height"
    :adaptive="true"
    :scrollable="false"
    :click-to-close="clickToClose"
    :classes="[
      'generic-modals',
      'v--modal',
      'new-modal',
      modalClasses
    ]"
    @before-open="beforeOpenAction"
    @before-close="beforeCloseAction"
    @closed="closedModal"
    ref="vueModal"
    role="dialog"
    aria-modal="true"
    :aria-describedby="dialogDesc && 'dialog-desc'"
    :aria-labelledby="(showHeaderAria || showStepsView || headerTitle) && 'customs-vmodal-header-title'"
  >
    <focus-trap :active="focusTrapState">
      <section
        :class="[
          'new-modal-wrapper',
          'customs-tools',
          {'new-modal-wrapper-no-buttons': !ctaPrimaryButton || !isCtaPrimaryButtonVisible }
        ]"
      >
        <div class="new-modal-top-nav">
          <div slot="top-left">
            <button
              type="button"
              v-show="isBackButtonVisible"
              class="new-modal-top-nav-back"
              :disabled="disableButtons || disableNextBackButtons"
              title="Back"
              @click="goBack"
              :aria-label="translations.ugcModalBack"
              role="button"
            >
              <customs-svg-icon
                :src="`${ assetsPath }/svg/customizer/icon-back.svg`"
                aria-hidden="true"
              ></customs-svg-icon>
            </button>
          </div>
          <modal-top-nav
            :headerImg="headerImg"
            :headerTitle="headerTitle"
            :showStepsView="showStepsView"
          ></modal-top-nav>
          <div slot="top-right" v-if="showCloseIcon">
            <button
              type="button"
              class="new-modal-top-nav-close"
              :disabled="disableButtons && !disableCloseButton"
              :id="`close-button-${modalName}`"
              title="Close"
              @click="closeAction()"
              :aria-label="translations.profanityCheckClose"
              role="button"
            >
              <customs-svg-icon
                :src="`${ assetsPath }/svg/customizer/icon-close.svg`"
                aria-hidden="true"
              ></customs-svg-icon>
            </button>
          </div>
        </div>
        <section class="new-modal-main-views-wrapper">
          <h2 v-if="title" class="new-modal-title">{{ translations[title] }}</h2>
          <p v-if="description" class="new-modal-description">{{ translations[description] }}</p>
          <slot :contentProps="contentProps" ></slot>
        </section>
        <modal-button-nav
          ref="modalButtonNav"
          :cta-primary-button="ctaPrimaryButton"
          :cta-secondary-button="ctaSecondaryButton"
          :show-icon-button="isIconButtonVisible"
          :cta-primary-button-icon-name="ctaPrimaryButtonIconName"
          :cta-primary-button-icon-type="ctaPrimaryButtonIconType"
          :show-cta-secondary-button="isCtaSecondaryButtonVisible"
          :show-cta-primary-button="isCtaPrimaryButtonVisible"
          :block-cta-primary-button="isCtaPrimaryBlocked || disableButtons || disableNextBackButtons"
          :block-cta-secondary-button="isCtaSecondaryBlocked || disableButtons"
          :cta-primary-tooltip="ctaPrimaryTooltip"
          :cta-secondary-tooltip="ctaSecondaryTooltip"
          @ctaSecondaryAction="ctaSecondaryAction"
          @ctaPrimaryAction="ctaPrimaryAction"
        ></modal-button-nav>
      </section>
    </focus-trap>
  </vue-modal>
</template>

<script>
import modalTopNav from '@/components/Globals/ModalTopNav';
import modalButtonNav from '@/components/Globals/ModalButtonNav';
import customsSvgIcon from '@/components/Globals/SvgIcon';
import { FocusTrap } from 'focus-trap-vue';

export default {
  name: "NewModalWrapper",
  components: {
    modalTopNav,
    modalButtonNav,
    customsSvgIcon,
    FocusTrap,
  },
  props: {
    modalName: {
      type: String,
      required: true
    },
    modalClasses: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    headerImg: {
      type: Boolean,
      default: true
    },
    headerTitle: {
      type: String,
      default: ''
    },
    showHeaderAria: {
      type: Boolean,
      default: false
    },
    ctaPrimaryButton: {
      type: String,
      default: ''
    },
    ctaPrimaryButtonArguments: {
      type: Object,
      default: null,
    },
    ctaPrimaryButtonIconName: {
      type: String,
      default: 'icon-next'
    },
    ctaPrimaryButtonIconType: {
      type: String,
      default: 'svg'
    },
    ctaSecondaryButton: {
      type: String,
      default: ''
    },
    showCloseIcon: {
      default: true,
      type: Boolean
    },
    clickToClose: {
      default: true,
      type: Boolean
    },
    widthModal: {
      type: String,
      default: '75%'
    },
    heightModal: {
      type: String,
      default: 'auto'
    },
    maxWidthModal: {
      type: Number,
      default: 500
    },
    showStepsView: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    disableButtons: {
      type: Boolean,
      default: false,
    },
    disableNextBackButtons: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'customizer',
    },
    disableCloseButton: {
      type: Boolean,
      default: false,
    },
    dialogDesc: {
      type: Boolean,
      default: false,
    },
    overrideFocusValue: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    assetsPath() {
      return this.$store.state.endPoints[this.type].customsAssets;
    },
    height() {
      if (this.fullHeight && this.isIframe
          && this.$store.getters["utils/returnScreenSize"].includes('mobile')) {
          return  window.parent.innerHeight;
      }
      if (this.fullHeight && this.screenSize.includes('mobile')) {
        return this.viewportHeight;
      }
      return this.heightModal;
    },
    screenSize() {
      return this.$store.getters["utils/returnScreenSize"];
    },
    isIframe() {
      return this.$store.getters['utils/noEsiActive'] && this.$store.getters['utils/isIframeSameOrigin'];
    },
    activeUgcFeatureId() {
      return this.$store.getters["ugc/tempData/getActiveUGCIndexId"];
    },
    focusTrapState() {
      return this.overrideFocusValue !== null ? this.overrideFocusValue : this.focusActive;
    }
  },
  data() {
    return {
      contentProps: {},
      isCtaPrimaryBlocked: false,
      isCtaSecondaryBlocked: false,
      ctaPrimaryTooltip: null,
      ctaSecondaryTooltip: null,
      isBackButtonVisible: false,
      isIconButtonVisible: false,
      isCtaSecondaryButtonVisible: true,
      isCtaPrimaryButtonVisible: true,
      viewportHeight: 0,
      focusActive: false
    };
  },
  methods: {
    /**
     * @function ctaPrimaryAction
     * Method to call function from content component.
     * It will be called onlye if the method exist in child component.
     */
    ctaPrimaryAction() {
      if (this.$listeners && this.$listeners['cta-action']) {
        this.$emit('cta-action', this.ctaPrimaryButtonArguments);
      } else {
        this.$modal.hide(this.modalName);
      }
    },
    /**
     * @function ctaSecondaryAction
     * Method to call function from content component.
     * It will be called onlye if the method exist in child component.
     */
    ctaSecondaryAction() {
      if (this.$listeners && this.$listeners['cta-secondary-action']) {
        this.$emit('cta-secondary-action');
      } else {
        this.$modal.hide(this.modalName);
      }
    },
    goBack() {
      if (this.$listeners && this.$listeners['go-back']) {
        if (this.$store.getters['utils/useEcomDataLayerFormat']) {
          this.$ugcDataLayer.logAnalyticsEvent({
            action: !!this.activeUgcFeatureId ? this.activeUgcFeatureId : 'ugc',
            type: this.$ugcDataLayer.types.backModal
          });
        }
        this.$emit('go-back');
      } else {
        this.$modal.hide(this.modalName);
      }
    },
    /**
     * @function beforeOpenAction
     * Method to receive the data sent to the modal.
     */
    beforeOpenAction(event) {
      this.contentProps = event.params ? event.params : {};
      if (this.$listeners && this.$listeners['before-open']) {
        this.$emit('before-open', event);
      }
      this.$eventBus.$emit('changeGlobalFocusState', { visible: false });
      this.focusActive = true;
    },
    /**
     * @function beforeCloseAction
     * Fires an event before the modal is closed.
     */
    beforeCloseAction(event) {
      if (this.$listeners && this.$listeners['before-close']) {
        this.$emit('before-close');
      }

      if(this.overrideFocusValue === null) this.$eventBus.$emit('changeGlobalFocusState', { visible: true });

      this.focusActive = false;
    },
    /**
     * @function closedModal
     * Fires an event when the modal is closed.
     */
    closedModal(event) {
      if (this.$listeners && this.$listeners['closed']) {
        this.$emit('closed');
      }
    },
    blockCtaPrimaryButton(value) {
      this.isCtaPrimaryBlocked = value;
    },
    blockCtaSecondaryButton(value) {
      this.isCtaSecondaryBlocked = value;
    },
    tooltipCtaPrimaryButton(value) {
      this.ctaPrimaryTooltip = value;
    },
    tooltipCtaSecondaryButton(value) {
      this.ctaSecondaryTooltip = value;
    },

    showBackButton(value) {
      this.isBackButtonVisible = value;
    },

    showIconButton(value) {
      this.isIconButtonVisible = value;
    },

    showCtaSecondaryButton(value) {
      this.isCtaSecondaryButtonVisible = value;
    },

    showCtaPrimaryButton(value) {
      this.isCtaPrimaryButtonVisible = value;
    },

    closeAction() {
      if (this.$listeners && this.$listeners['close-action']) {
        this.$emit('close-action');
      } else {
        this.$modal.hide(this.modalName);
        this.isCtaSecondaryBlocked = false;
        this.isBackButtonVisible = false;
        this.isIconButtonVisible = false;
        this.$nextTick(()=>{
          document.querySelector(".new-modal-top-nav-close").focus();
        });
      }
    },
    updateViewportHeight() {
      this.viewportHeight = window.innerHeight;
    }
  },
  mounted () {
    this.focusActive = false;
  },
  created() {
    this.updateViewportHeight();
    window.addEventListener('resize', this.updateViewportHeight);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportHeight);
    this.focusActive = false;
  }
};
</script>
